import type React from 'react';

import { PageBody } from '../components/PageBody';
import { PageHeading } from '../components/PageHeading';

import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC<EmptyProps> = () => {
	useTrackPageView();

	return (
		<>
			<PageHeading />
			<PageBody />
		</>
	);
};
